import { Route, Routes } from 'react-router-dom'
import { TableOptionMenu } from './table'

export const BrowserOptionMenu = () => {
  return (
    <Routes>
      <Route path={"/"} element={<TableOptionMenu />} />
    </Routes>
  )
}